import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=2f9677c4&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=2f9677c4&prod&lang=css"
import style1 from "./overview.vue?vue&type=style&index=1&id=2f9677c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9677c4",
  null
  
)

export default component.exports